<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onChangecompany="onChangecompany"
        @editAndAdd="editAndAdd"
        @importShow="importShow"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="(record) => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: (total) => `共${total}条`,
        }"
        @change="changePage"
      >
        <template slot="drugs_count" slot-scope="text, record">
          <a @click="handleCompanyList(record)">{{ record.drugs_count }}</a>
        </template>
        <template slot="doctor_count" slot-scope="text, record">
          <a @click="handleDoctorList(record)">{{ record.doctor_count }}</a>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a href="javascript:;" @click="() => editAndAdd(record)">编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status === 1 ? '禁用' : '启用'"
            :alert-title="record.status === 1 ? '确定禁用？' : '确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider v-if="role === 0" type="vertical" />
          <a
            v-if="role === 0"
            href="javascript:;"
            @click="() => bindArea(record)"
            >大区</a
          >
          <a-divider type="vertical" />
          <a href="javascript:;" @click="() => allotBuesness(record)"
            >分配客户</a
          >
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :type-id="typeId"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </add-edit-modal>
    <doctor-list
      :data="doctorData"
      :visible="visibleDoctor"
      @onCancel="onCancelDoctor"
    >
      <form-button
        :show-msg="false"
        @onCancel="onCancelDoctor"
        @onSubmit="onCancelDoctor"
      />
    </doctor-list>

    <a-modal
      class="client-modal-wrapper hospital-modal"
      :destroy-on-close="true"
      width="1400px"
      :mask-closable="false"
      :visible="ImportReadhospitalVisible"
      :footer="null"
      title="导入推广人"
      @cancel="onCancel1"
    >
      <a-upload
        name="upload"
        style="margin-right: 20px"
        :with-credentials="false"
        :data="{ fileType: 'file' }"
        :action="`${uploadUrl}fileup/upload`"
        @change="(event) => importDoctors(event)"
      >
        <a-tooltip placement="bottom">
          <template slot="title">
            <span>提示：按照模板格式导入</span>
          </template>
          <a-button shape="round">
            <a-icon type="upload" /> 批量导入推广人
          </a-button>
        </a-tooltip>
      </a-upload>
      <div>
        支持上传xls和xlsx格式文件，不超过10M，<a
          href="javascript:;"
          @click="xiazai"
          >点击下载Excel模板</a
        >。请按模板格式录入数据，格式错误将导致导入失败。
      </div>
      <div>
        <a-table
          :scroll="{ y: 500, x: 1000 }"
          :columns="columns3"
          :data-source="data1"
          :loading="loading1"
          :row-key="(record) => record.line"
          :pagination="false"
          class="yc"
        >
          <template slot="error_msg" slot-scope="text, record">
            <div v-if="record.error == true" style="color: red">
              {{ record.error_msg }}
            </div>
            <div v-if="record.error !== true">{{ record.error_msg }}</div>
          </template>
        </a-table>
      </div>
    </a-modal>

    <!-- 分配拜访客户 -->
    <allot-business-modal
      ref="allotBusinessRef"
      :allotBusinessVisible="allotBusinessVisible"
      :allotUserId="allotUserId"
      :allotUserName="allotUserName"
      :currCompanyId="currCompanyId"
    >
    </allot-business-modal>
  </div>
</template>
<script>
import { columns1, columns2, columns3 } from "./data/index";
import TableSearch from "./components/search";
import addEditModal from "./modal/index";
import allotBusinessModal from "./modal/allotBusiness";
import doctorList from "./modal/doctorList";
import areaPanel from "./components/area";

var pageContext;
export default {
  components: { TableSearch, addEditModal, doctorList, allotBusinessModal },
  data() {
    return {
      ImportReadhospitalVisible: false,
      loading1: false,
      columns3,
      data1: [],
      columns: [],
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: "",
      visible: false,
      allotBusinessVisible: false,
      allotUserName: "",
      allotUserId: "",
      currCompanyId: "",
      typeId: "",
      id: "",
      CompanyData: [],
      visibleCompany: false,
      doctorData: [],
      visibleDoctor: false,
      role: 0,
      token: "",
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    pageContext = this;
    this.role = this.$store.state.user.role;
    if (this.role === 0) {
      this.columns = columns1;
    } else {
      this.columns = columns2;
    }
    // 获取表格数据
    this.getTableData({
      page: this.current,
      pageSize: this.pageSize,
      keyword: this.keyword,
    });
  },
  methods: {
    onChangecompany(companyId) {
      this.currCompanyId = companyId;
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let url =
        this.role === 0 ? "/promoter/getList" : "/promoter/getPromoterList";
      let result = await this.$http.post(url, params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.promoters.id,
            status: item.promoters.user_status,
            user_nickname: item.promoters.user_nickname,
            user_realname: item.promoters.user_realname,
            mobile: item.promoters.mobile,
            create_time: this.$Format(item.create_time),
            name:
              item.bindArea && !Array.isArray(item.bindArea)
                ? item.bindArea.area_info.name
                : "",
            score: item.promoters.score,
            drugs_count: item.promoters.drugs_count,
            doctor_count: item.doctor_count,
            task_finish_count: item.promoters.task_finish_count,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },

    async getTableData1(params) {
      this.loading1 = true;
      let result = await this.$http.post(
        "/promoter/promoterImportRead",
        params
      );
      if (result.data.status === 1) {
        this.loading1 = false;
        this.total1 = result.data.data.count;
        let data = result.data.data;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            line: item.line,
            user_realname: item.user_realname,
            user_nickname: item.user_nickname,
            sex: item.sex,
            mobile: item.mobile,
            province: item.province,
            city: item.city,
            introduction: item.introduction,
            error_msg: item.error_msg,
            error: item.error,
          };
          temp.push(obj);
        });
        this.data1 = temp;
        this.current = 1;
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
        });
      }
    },
    async xiazai() {
      window.open(
        `${this.uploadUrl}/fileup/downLoadImportExcel?name=promoter&token=${this.token}`
      );
    },
    // 搜索
    onSearch(value) {
      this.current = 1;
      this.keyword = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
      });
    },
    // 分配拜访客户
    allotBuesness(record) {
      console.log("editAndAdd -> record", record);
      this.allotBusinessVisible = true;
      this.allotUserId = record.id;
      this.allotUserName = record.user_realname;
    },
    // 关闭分配的窗口
    allotBuesnessCancel() {
      this.allotUserId = "";
      this.allotUserName = "";
      this.allotBusinessVisible = false;
    },
    // 编辑或新增
    async editAndAdd(record) {
      console.log("editAndAdd -> record", record);
      this.visible = true;
      if (!record) {
        this.title = "新增推广员";
        this.id = "";
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.title = "编辑推广员";
        let result = await this.$http.post("/promoter/getDrugsList", {
          id: record.id,
        });
        if (result.data.status === 1) {
          this.typeId = record.data.bind_type;
          this.id = record.id;
          let data = {
            user_realname: record.data.promoters.user_realname,
            user_nickname: record.data.promoters.user_nickname,
            bind_type: record.data.promoters.bind_type,
            drugs: result.data.data.data_list.map((item) => {
              return item.drug_id;
            }),
            sex: record.data.promoters.sex,
            provinceCity: {
              province: record.data.promoters.province_id,
              city: record.data.promoters.city_id,
            },
            mobile: record.data.promoters.mobile,
            introduction: record.data.promoters.introduction,
          };
          this.$nextTick(() => {
            this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
          });
        }
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async (err, values) => {
          if (!err) {
            values.province_id = values.provinceCity.province;
            values.city_id = values.provinceCity.city;
            values.path = `0,${values.provinceCity.province},${values.provinceCity.city}`;
            this.btnIsLoading = true;

            var args = {
              type: this.type,
              ...values,
            };
            if (this.id === "") {
              args.bindArea = localStorage.getItem("bindArea");
            } else {
              args.id = this.id;
            }

            let result = await this.$http.post("/promoter/update", args);
            this.btnIsLoading = false;
            if (result.data.status === 1) {
              this.$message.success("操作成功！");
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
                type: this.typeId ? this.typeId : undefined,
                keyword: this.keyword,
              });
              this.visible = false;
            }
          }
        }
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result = await this.$http.post("/promoter/canChange", {
        id: record.id,
        user_status: record.status === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success("操作成功！");
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          type: this.typeId ? this.typeId : undefined,
          keyword: this.keyword,
        });
      }
    },
    // 查看关联企业
    async handleDoctorList(record) {
      this.visibleDoctor = true;
      let result = await this.$http.post("/promoter/getDoctorsList", {
        id: record.id,
      });
      if (result.data.status === 1) {
        this.doctorData = result.data.data.data_list;
      }
    },

    importShow() {
      this.data1 = [];
      this.ImportReadhospitalVisible = true;
    },
    onCancel1() {
      this.ImportReadhospitalVisible = false;
    },
    async importDoctors(event) {
      console.log("importDoctors -> event", event);
      if (event.file.response && event.file.response.status === 0) {
        this.$message.warning(event.file.response.msg);
      }
      if (event.file.response && event.file.response.status === 1) {
        let id = event.file.response.data.id;
        this.daoruid = id;
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        let res = await this.$http.post("/promoter/importPromoter", { id });
        console.log("importDoctors -> res", res);
        loading.close();
        if (res.data.status === 1) {
          this.getTableData1({
            page: this.current,
            pageSize: this.pageSize,
            id: id,
          });
          this.$message.success("操作成功！");
        }
      }
    },

    // 关闭查看关联医生
    onCancelDoctor() {
      this.visibleDoctor = false;
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
      });
    },
    // 关联大区
    bindArea(record) {
      pageContext.$layer.iframe({
        content: {
          content: areaPanel,
          parent: this,
          data: {
            itemData: record,
          },
        },
        area: ["900px", "600px"],
        title: "关联大区",
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info("操作取消！");
        },
      });
    },
    refreshDataList() {
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.yc .ant-table-tbody > tr > td {
  padding: 10px 4px !important;
}
/deep/.yc .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
</style>
